import Translate from '../../UI/ReaderSelectionTool/integrations/translate.vue';
import ListenApi from '../../UI/ReaderSelectionTool/integrations/listen-api.vue';
import ListenNative from '../../UI/ReaderSelectionTool/integrations/listen-native.vue';
import Dictionary from '../../UI/ReaderSelectionTool/integrations/dictionary.vue';
import AiIntegrations from '../../UI/ReaderSelectionTool/integrations/ai-integrations.vue';

export default {
    integrationsBaseEndpoint: '/integrations',
    items: {
        translate: {
            name: 'Translate',
            component: Translate,
            isActive: false,
            endpoint: '/translate',
        },
        listen: {
            name: 'Listen',
            component: ListenApi,
            isActive: false,
            endpoint: '/listen',
        },
        'native-tts': {
            name: 'NativeTts',
            component: ListenNative,
            isActive: false,
            endpoint: '/native-tts',
        },
        dictionary: {
            name: 'Dictionary',
            component: Dictionary,
            isActive: false,
            endpoint: '/dictionary',
        },
        'ai-integrations': {
            name: 'AiIntegrations',
            component: AiIntegrations,
            isActive: true,
            endpoint: '/ai-integrations',
        },
    },
};
